/**
 * Admin 태그 관리. 라우트 admin.php tags 그룹과 동기화.
 * index: 연결된 게시판 보기 모달
 */
function initTagBoardsModal(): void {
    const modal = document.getElementById("tag-boards-modal");
    const tagNameEl = document.getElementById("tag-boards-modal-tag-name");
    const listEl = document.getElementById("tag-boards-modal-list");

    function open(data: string | { tagName?: string; boards?: Array<{ name?: string; code?: string }> }): void {
        const d = typeof data === "string" ? (JSON.parse(data) as { tagName?: string; boards?: Array<{ name?: string; code?: string }> }) : data;
        if (tagNameEl) tagNameEl.textContent = "태그: " + (d.tagName ?? "");
        if (listEl) {
            listEl.innerHTML = "";
            (d.boards ?? []).forEach((b) => {
                const li = document.createElement("li");
                li.textContent = (b.name ?? "") + (b.code ? " (" + b.code + ")" : "");
                listEl.appendChild(li);
            });
        }
        if (modal) {
            modal.hidden = false;
            modal.setAttribute("aria-hidden", "false");
        }
    }

    function close(): void {
        if (modal) {
            modal.hidden = true;
            modal.setAttribute("aria-hidden", "true");
        }
    }

    document.querySelectorAll("[data-tag-boards-open]").forEach((btn) => {
        btn.addEventListener("click", () => {
            const data = btn.getAttribute("data-tag-boards");
            if (data) open(data);
        });
    });
    document.querySelectorAll("[data-tag-boards-close]").forEach((el) => {
        el.addEventListener("click", close);
    });
    if (modal) {
        modal.addEventListener("keydown", (e) => {
            if (e.key === "Escape") close();
        });
    }
}

export const TagController = {
    index(): void {
        initTagBoardsModal();
    },
    edit(): void {
        // 태그 수정 페이지 전용 초기화 없음
    },
};
